import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.less';
import App from './App';

const container = document.getElementById('loginRoot');
const root = createRoot(container);
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
